var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-button',{staticClass:"filters-reset-button",attrs:{"name":"Сбросить фильтры","type":"text-base","icon":"reset_filter_list","offset-icon":"4px","padding-left":"6px","padding-right":"10px","height":"32px"},on:{"click":_vm.resetFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }